import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import './driver.css'; 

/**
 * Inicia un tour guiado usando driver.js
 */
export const iniciarTour = () => {
  const driverObj = driver({
    
    nextBtnText: 'Siguiente -›',
    prevBtnText: '‹- Anterior',
    doneBtnText: '✕',
    showProgress: false,
    allowClose: false,
    animate: true,
    popoverClass: 'driverjs-theme',
    onPopoverRender: (popover, hook) => {
    // Botón de "Salir"
    const exitButton = document.createElement("button");
    exitButton.innerText = "✕ Salir";
    exitButton.style.position = "absolute";
    exitButton.style.top = "8px";
    exitButton.style.right = "8px";
    exitButton.style.backgroundColor = "#ec5252"; // Azul claro
    exitButton.style.color = "white";
    exitButton.style.padding = "5px 10px";
    exitButton.style.borderRadius = "5px";
    exitButton.style.boxShadow = "0 2px 5px rgba(0, 0, 0, 0.2)";
    exitButton.style.fontSize = "16px";
    exitButton.style.cursor = "pointer";
    exitButton.title = "Salir del tutorial";

    // Acción al hacer clic en "Salir"
    exitButton.addEventListener("click", () => {
      driverObj.destroy(); // Detiene el tour
    });

    // Añadimos el botón al popover
    popover.wrapper.appendChild(exitButton);
  },
    
    steps: [
        {
        element: '#btn', // Puedes apuntar al botón del tour o dejarlo sin elemento
        popover: {
            title: 'Bienvenido al Modo Tutorial',
            description:
            '<img src="welcome.jpg" style="height: 200px; width: 230px; align-items:center; justify-content:center;" /> ¡Hola! 👋 Este es un recorrido guiado por los principales elementos de esta pantalla. Usa los botones "Anterior" y "Siguiente" para navegar. ¡Comencemos!',
            align: 'center', // Centra el popover en la pantalla
        },
        },
      {
      element: '#case-status-priorizado',
      popover: {
        title: 'BOTON DE FILTRO **CASOS PRIORIZADOS**',
        description: 'Este botón muestra el número total de casos priorizados y permite filtrar la lista de casos para mostrar únicamente aquellos marcados como priorizados.<img src="btn1.png" style="height: 200px; width: 230px; align-items:center; justify-content:center;" />',
        
        onNextClick: () => {
          console.log("Loading dynamic element...");
          driverObj.moveNext();
        },
      },
    },
      {
        element: '#case-status-pendiente',
        popover: {
          title: 'BOTON DE FILTRO **CASOS PENDIENTES**',
          description: 'Este botón muestra el número total de casos pendientes y permite filtrar la lista de casos para mostrar únicamente aquellos con estado "Pendiente".<img src="btn1.png" style="height: 200px; width: 230px; align-items:center; justify-content:center;" />',
          onNextClick: () => {
          console.log("Loading dynamic element2...");
          funcionClick('case-status-pendiente'); // Simula el clic si es necesario
          driverObj.moveNext();
        },
   
        },
        
      },
      {
        element: '#case-status-agendado',
        popover: {
          title: 'BOTON DE FILTRO **CASOS AGENDADOS**',
          description: 'Este botón muestra el número total de casos agendados y permite filtrar la lista de casos para mostrar únicamente aquellos con estado "Agendado".<img src="btn1.png" style="height: 200px; width: 230px; align-items:center; justify-content:center;" />',
          onNextClick: () => {
          console.log("Loading dynamic element3...");
          driverObj.moveNext();
        },

        }
      },
      {
        element: '#case-status-atendido',
        popover: {
          title: 'BOTON DE FILTRO **CASOS ATENDIDOS**',
          description: 'Este botón muestra el número total de casos atendidos y permite filtrar la lista de casos para mostrar únicamente aquellos con estado "Atendido".<img src="btn1.png" style="height: 200px; width: 230px; align-items:center; justify-content:center;" />',
          onNextClick: () => {
          console.log("Loading dynamic element4...");
          driverObj.moveNext();
        },
        }
      },
      {
        element: '#case-status-remesado',
        popover: {
          title: 'BOTON DE FILTRO **CASOS ATENDIDOS**',
          description: 'Este botón muestra el número total de casos remesados y permite filtrar la lista de casos para mostrar únicamente aquellos con estado "Remesado".<img src="btn1.png" style="height: 200px; width: 230px; align-items:center; justify-content:center;" />',
        }
      },
      
      {
        element: '.p-column-filter-menu-button',
        popover: {
          title: 'FILTRO AVANZADO DE COLUMNAS',
          description: '<img src="btn2.jpg" style="height: 200px; width: 230px; align-items:center; justify-content:center;" />Este botón permite activar el filtrado avanzado de columnas en la tabla de casos médicos. Al hacer clic en él, podrás introducir términos de búsqueda específicos para cada columna de la tabla.',
          onNextClick: () => {

            console.log("Loading filter...");
            funcionClass('p-column-filter-menu-button');      
            setTimeout(() => {
                driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
            }, 200); // Ajusta este tiempo según sea necesario
          
        },
        },
       
      }, 
      { 
        element: '.p-column-filter-overlay',
          popover: {
            title: 'FILTRO POR COLUMNA',
            description: 'Ventana emergente que muestra opciones de filtrado personalizadas por columna.',
            onNextClick: () => {
            
                
            
              driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
            
          },
        }
       
      },
      
      
       {
            element: '#details-buttong',
            popover: {
                title: 'BOTÓN "Ver" PARA DETALLES DEL CASO',
                description: "<img src='/btn1.png' style='height: 202.5px; width: 250px;' /><span style='font-size: 15px; display: block; margin-top: 10px; text-align: center;'>Este botón te permite ver los detalles completos de un caso médico específico. <strong>Por favor, haz clic en 'Siguiente'</strong> para continuar con el tutorial.</span>",
                onNextClick: () => {
                console.log("Simulando clic en el botón 'Ver'");
                funcionClick('details-buttong'); // Simula el clic si es necesario
                driverObj.moveNext(); // Avanza al siguiente paso
                },
            }
            },
      {
       
        popover: {
            title: 'Continúa con el Tour',
            description: "<img src='/continue1.jpeg' style='height: 202.5px; width: 250px;' />¡Lo estás haciendo genial! Haz clic en <strong>Siguiente</strong> para seguir explorando el tutorial. ",
            showButtons: ['next'],
            }
      },
      {
        element: '#detallesproveedor',
        popover: {
          title: 'Detalles del Caso Médico',
          description: "Aquí encontrarás la información principal del caso médico:\n\n" +
                        "- Número de Orden: Identificador único del caso.\n" +
                        "- Siniestro: Código del evento o reclamación asociado.\n" +
                        "- Proveedor: Institución médica encargada del tratamiento.",
        }
      },
      {
        element: '#detallesdelcreador',
        popover: {
          title: 'Sección Creador del Caso',
          description: 'Muestra quién creó este caso en el sistema. Aquí encontrarás el nombre y correo electrónico del creador, lo cual puede ser útil para contactarlo si necesitas más información.',
        }
      },
      {
        element: '#detallesdelpaciente',
        popover: {
          title: 'Sección Datos del Paciente',
          description: 'Esta sección contiene información personal del paciente, como cédula, nombre, teléfonos y fecha de nacimiento. Esta información es crucial para identificar al paciente correctamente y proporcionar atención adecuada.',
        }
      },
      {
        element: '#detallesdelservicio',
        popover: {
          title: 'Sección Datos del Caso y Servicio',
          description: 'Aquí se detallan aspectos específicos del caso, como el diagnóstico principal, el proveedor involucrado y la fecha de atención. También puedes ver otros servicios o procedimientos relacionados con el caso.',
        }
      },
     
      {
        element: '#edit-case-linkg',
        popover: {
          title: 'Botón Editar Caso',
          description: 'Puedes actualizar información crítica como el estado, los diagnósticos o los servicios asociados.',
          onNextClick: () => {
                // .. load element dynamically
                // .. and then call

                console.log("Loading dynamic element5...");
                funcionClick('edit-case-linkg');
                driverObj.moveNext();
            },
        }
      },
      {
        element: '#edit-case-formg',
        popover: {
          title: 'Edición de Datos',
          description:  "<img src='/edit.png' style='height: 210px; width: 250px;' /><span style='font-size: 15px; display: block; margin-top: 10px; text-align: center;'>Este botón te permite ver los detalles completos de un caso médico específico. <strong>Por favor, haz clic en 'Siguiente'</strong> para continuar con el tutorial.</span>",
          showButtons: ['next'],
        }
      },
      {
        element: '#edit-case-formg',
        popover: {
          title: 'Edición de Datos',
          description: 'Este apartado te permite editar los detalles del titular, paciente y caso; como la cédula, nombre completo, sexo, fecha de nacimiento, condición (activo, jubilado, sobreviviente), números de teléfono y otros datos relevantes.',
        }
      },
     
      {
        element: '#backg',
        popover: {
          title: 'Volver',
          description: 'vamos a volver al detalle del caso',
           onNextClick: () => {
                // .. load element dynamically
                // .. and then call

                console.log("Loading dynamic element5...");
                funcionClick('backg');
                driverObj.moveNext();
            },
        }
      },
      {
        element: '#case-status-wrapper',
        popover: {
          title: "<img src='/vuelta.jpg' style='height: 210px; width: 250px;' />De vuelta a la seccion de Detalle del caso, continuemos",
          description: '',
        }
      },
      {
        element: '#displayg',
        popover: {
          title: 'Estado del caso',
          description: 'El estado del caso es crucial para su gestión. Aquí puedes ver el estado actual del caso, que puede ser "Pendiente", "Agendado", "Atendido", etc. Asegúrate de actualizarlo según corresponda.',
          onNextClick: () => {
            console.log("Mostrando estado del caso...");
            driverObj.moveNext();
          },
        }
      },
      {
        element: '#btn-schedule-case',
        popover: {
          title: '**BOTON AGENDAR CASO**',
          description: '<strong>USO:</strong>\n\n\n\n Este botón te permite agendar una cita para el caso médico actual y cambiar el estatus de <strong>PENDIENTE</strong> a <strong>AGENDADO</strong>. Al hacer clic, se abrirá un modal donde podrás seleccionar la fecha y hora de la cita.',
          onNextClick: () => {
                // .. load element dynamically
                // .. and then call

                console.log("Loading dynamic element5...");
                funcionClick('btn-schedule-case');
                setTimeout(() => {
                    
                    driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
                }, 200); // Ajusta este tiempo según sea necesario
            },
        }
      },
      
     
       {
        element: '#hospital-pending-modal-demo',
        popover: {
          title: 'Modal de Caso Pendiente',
          description: 'Este modal se muestra cuando se intenta agendar un caso pendiente',
          onNextClick: () => {

                console.log("Loading dynamic element5...");
                funcionClick('schedule-buttong');
                
                driverObj.moveNext();
            },
        }
      },
      {
        element: '#hospital-pending-modal-demo',
        popover: {
          title: 'Modal de Caso Pendiente',
          description: 'en este apartado se puede escoger la fecha',
          onNextClick: () => {

                console.log("Loading dynamic element5...");
                funcionClick('confirm-schedule-buttong');
                
                driverObj.moveNext();
            },
        }
      },
       {
        element: '#displayg',
        popover: {
          title: 'Estado del Caso',
          description: 'Mostrar cambio de estado a Agendado',
          onNextClick: () => {
            console.log("Mostrando estado del caso...");
            driverObj.moveNext();
          },
        }
      },
     
      {
        element: '.check',
        popover: {
          title: 'Marcar requerimientos',
          description: 'Puedes marcar los requerimientos del caso que ya fueron realizados.',
        }
      },
      
      {
        element: '.p-tooltip-target-wrapper',
        popover: {
          title: 'Marcar como Atendido',
          description: 'Al marcar como Atendido, se actualizará el estado del caso a "Atendido" y se habilitarán nuevas opciones.',
           onNextClick: () => {
                console.log("Loading dynamic element5...");
                
                funcionClick('btn-attend-case');
                
                setTimeout(() => {
                    
                    driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
                }, 200); // Ajusta este tiempo según sea necesario
                 
            },
        }
      },
      {
        element: '#demo-dialoggg',
        popover: {
          title: 'Modal de confirmación',
          description: 'este modal se muestra para confirmar que el caso ha sido atendido correctamente.',
          onNextClick: () => {
                   console.log("Loading dynamic element5...");
                   funcionClick('btn-confirm-demo');
                   setTimeout(() => {
                    
                    driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
                }, 200); // Ajusta este tiempo según sea necesario
            },
        }
      },
      
      {
        element: '.p-tooltip-target-wrapper',
        popover: {
          title: 'El compromiso es generado',
          description: 'el boton de atendido cambiara y se generara un compromiso en pdf',
        }
      },
      {
        element: '#facturag',
        popover: {
          title: 'Carga de Factura',
          description: 'se puede cargar una factura para el caso atendido. Esto es importante para el proceso de facturación y seguimiento del caso.',
        }
      },
      {
        element: '.btn-agregarsoporte',
        popover: {
          title: 'Agregar Soporte',
          description: 'se puede agregar un soporte adicional al caso. Esto puede incluir documentos, imágenes u otra información relevante que respalde el caso médico.',
        }
      },
      {
        element: '#btn-remesar-demog',
        popover: {
          title: '**BOTON DE REMESAR**',
          description: 'Este botón te permite cambiar el estado del caso médico actual a "Remesado"',
          onNextClick: () => {
                   console.log("Loading dynamic element5...");
                   funcionClick('btn-remesar-demog');
                   setTimeout(() => {
                    
                    driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
                }, 200); // Ajusta este tiempo según sea necesario
            },
        }
      },
      
      {
        element: '#remesar-case-dialoggg',
        popover: {
          title: 'MODAL DE CONFIRMACION',
          description: 'Asegurate de dejar una observacion al confirmar el estatus de <strong>Remesar</strong> esto es importante para el seguimiento del caso.',
          onNextClick: () => {
                   console.log("Loading dynamic element5...");
                   funcionClick('cancel-remesar-buttongg');
                   setTimeout(() => {
                    
                    driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
                }, 300); // Ajusta este tiempo según sea necesario
            },
        }
      },
      {
        element: '#remesar-case-dialoggg',
        popover: {
          title: 'COMPLETADO',
          description: "<img src='/celebration.jpg' style='height: 190px; width: 250px;' />¡Has completado el recorrido! Ahora sabes cómo gestionar los casos médicos en el sistema. Puedes explorar este recorrido en el modo demo",
          
        }
      },
    ]
  });

  driverObj.drive(); // ¡Importante! Inicia el tour aquí
};



export const iniciarTour2 = () => {
  const driverObj = driver({
    
    nextBtnText: 'Siguiente -›',
    prevBtnText: '‹- Anterior',
    doneBtnText: '✕',
    showProgress: false,
    allowClose: false,
    animate: true,
    popoverClass: 'driverjs-theme',
    onPopoverRender: (popover, hook) => {
    // Botón de "Salir"
    const exitButton = document.createElement("button");
    exitButton.innerText = "✕ Salir";
    exitButton.style.position = "absolute";
    exitButton.style.top = "8px";
    exitButton.style.right = "8px";
    exitButton.style.backgroundColor = "#ec5252"; // Azul claro
    exitButton.style.color = "white";
    exitButton.style.padding = "5px 10px";
    exitButton.style.borderRadius = "5px";
    exitButton.style.boxShadow = "0 2px 5px rgba(0, 0, 0, 0.2)";
    exitButton.style.fontSize = "16px";
    exitButton.style.cursor = "pointer";
    exitButton.title = "Salir del tutorial";

    // Acción al hacer clic en "Salir"
    exitButton.addEventListener("click", () => {
      driverObj.destroy(); // Detiene el tour
    });

    // Añadimos el botón al popover
    popover.wrapper.appendChild(exitButton);
  },
    steps: [
      {
        element: '#detallesproveedor',
        popover: {
          title: 'Detalles del Caso Médico',
            description: "Aquí encontrarás la información principal del caso médico:\n\n" +
                        "- Número de Orden: Identificador único del caso.\n\n" +
                        "- Siniestro: Código del evento o reclamación asociado.\n" +
                        "- Proveedor: Institución médica encargada del tratamiento.",
        
        }
      },
      {
        element: '#detallesdelcreador',
        popover: {
          title: 'Sección Creador del Caso',
          description: 'Muestra quién creó este caso en el sistema. Aquí encontrarás el nombre y correo electrónico del creador, lo cual puede ser útil para contactarlo si necesitas más información.',
        }
      },
      {
        element: '#detallesdelpaciente',
        popover: {
          title: 'Sección Datos del Paciente',
          description: 'Esta sección contiene información personal del paciente, como cédula, nombre, teléfonos y fecha de nacimiento. Esta información es crucial para identificar al paciente correctamente y proporcionar atención adecuada.',
        }
      },
      {
        element: '#detallesdelservicio',
        popover: {
          title: 'Sección Datos del Caso y Servicio',
          description: 'Aquí se detallan aspectos específicos del caso, como el diagnóstico principal, el proveedor involucrado y la fecha de atención. También puedes ver otros servicios o procedimientos relacionados con el caso.',
        }
      },
     
      {
        element: '#edit-case-linkg',
        popover: {
          title: 'Botón Editar Caso',
          description: 'Puedes actualizar información crítica como el estado, los diagnósticos o los servicios asociados.',
          onNextClick: () => {
                // .. load element dynamically
                // .. and then call

                console.log("Loading dynamic element5...");
                funcionClick('edit-case-linkg');
                driverObj.moveNext();
            },
        }
      },
      {
        element: '#edit-case-formg',
        popover: {
          title: 'Edición de Datos',
          description: "<img src='/edit.png' style='height: 210px; width: 250px;' /><span style='font-size: 15px; display: block; margin-top: 10px; text-align: center;'>Este botón te permite ver los detalles completos de un caso médico específico. <strong>Por favor, haz clic en 'Siguiente'</strong> para continuar con el tutorial.</span>",
          showButtons: ['next'],
        }
      },
      {
        element: '#edit-case-formg',
        popover: {
          title: 'Edición de Datos',
          description: 'Este apartado te permite editar los detalles del titular, paciente y caso; como la cédula, nombre completo, sexo, fecha de nacimiento, condición (activo, jubilado, sobreviviente), números de teléfono y otros datos relevantes.',
        }
      },
     
      {
        element: '#backg',
        popover: {
          title: 'Volver',
          description: 'vamos a volver al detalle del caso',
           onNextClick: () => {
                // .. load element dynamically
                // .. and then call

                console.log("Loading dynamic element5...");
                funcionClick('backg');
                driverObj.moveNext();
            },
        }
      },
      {
        element: '#case-status-wrapper',
        popover: {
          title: "<img src='/vuelta.jpg' style='height: 210px; width: 250px;' />De vuelta a la seccion de Detalle del caso, continuemos",
          description: '',
        }
      },
      {
        element: '#displayg',
        popover: {
          title: 'Estado del caso',
          description: 'El estado del caso es crucial para su gestión. Aquí puedes ver el estado actual del caso, que puede ser "Pendiente", "Agendado", "Atendido", etc.',
          onNextClick: () => {
            console.log("Mostrando estado del caso...");
            driverObj.moveNext();
          },
        }
      },
       {
        element: '#btn-schedule-case',
        popover: {
          title: '**BOTON AGENDAR CASO**',
          description: '<strong>USO:</strong>\n\n\n\n Este botón te permite agendar una cita para el caso médico actual y cambiar el estatus de <strong>PENDIENTE</strong> a <strong>AGENDADO</strong>. Al hacer clic, se abrirá un modal donde podrás seleccionar la fecha y hora de la cita.',
          onNextClick: () => {
                // .. load element dynamically
                // .. and then call

                console.log("Loading dynamic element5...");
                funcionClick('btn-schedule-case');
                setTimeout(() => {
                    
                    driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
                }, 200); // Ajusta este tiempo según sea necesario
            },
        }
      },
     
       {
        element: '#hospital-pending-modal-demo',
        popover: {
          title: 'Modal de Caso Pendiente',
          description: 'Este modal se muestra cuando se intenta agendar un caso pendiente',
          onNextClick: () => {

                console.log("Loading dynamic element5...");
                funcionClick('schedule-buttong');
                
                driverObj.moveNext();
            },
        }
      },
      {
        element: '#hospital-pending-modal-demo',
        popover: {
          title: 'Modal de Caso Pendiente',
          description: 'en este apartado se puede escoger la fecha',
          onNextClick: () => {

                console.log("Loading dynamic element5...");
                funcionClick('confirm-schedule-buttong');
                
                driverObj.moveNext();
            },
        }
      },
       {
        element: '#displayg',
        popover: {
          title: 'Estado del Caso',
          description: 'Mostrar cambio de estado a Agendado',
          onNextClick: () => {
            console.log("Mostrando estado del caso...");
            driverObj.moveNext();
          },
        }
      },
     
      {
        element: '.check',
        popover: {
          title: 'Marcar requerimientos',
          description: 'Puedes marcar los requerimientos del caso que ya fueron realizados. ',
        }
      },
      
      {
        element: '.p-tooltip-target-wrapper',
        popover: {
          title: 'Marcar como Atendido',
          description: 'Al marcar como Atendido, se actualizará el estado del caso a "Atendido" y se habilitarán nuevas opciones.',
           onNextClick: () => {
                console.log("Loading dynamic element5...");
                
                funcionClick('btn-attend-case');
                
                setTimeout(() => {
                    
                    driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
                }, 200); // Ajusta este tiempo según sea necesario
                 
            },
        }
      },
      {
        element: '#demo-dialoggg',
        popover: {
          title: 'Modal de confirmación',
          description: 'este modal se muestra para confirmar que el caso ha sido atendido correctamente.',
          onNextClick: () => {
                   console.log("Loading dynamic element5...");
                   funcionClick('btn-confirm-demo');
                   setTimeout(() => {
                    
                    driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
                }, 200); // Ajusta este tiempo según sea necesario
            },
        }
      },
      
      {
        element: '.p-tooltip-target-wrapper',
        popover: {
          title: 'El compromiso es generado',
          description: 'el boton de atendido cambiara y se generara un compromiso en <strong>PDF</strong>',
        }
      },
      {
        element: '#facturag',
        popover: {
          title: 'Carga de Factura',
          description: 'se puede cargar una factura para el caso atendido. Esto es importante para el proceso de facturación y seguimiento del caso.',
        }
      },
      {
        element: '.btn-agregarsoporte',
        popover: {
          title: 'Agregar Soporte',
          description: 'se puede agregar un soporte adicional al caso. Esto puede incluir documentos, imágenes u otra información relevante que respalde el caso médico.',
        }
      },
      {
        element: '#btn-remesar-demog',
        popover: {
          title: '**BOTON DE REMESAR**',
          description: 'Este botón te permite cambiar el estado del caso médico actual a "Remesado"',
          onNextClick: () => {
                   console.log("Loading dynamic element5...");
                   funcionClick('btn-remesar-demog');
                   setTimeout(() => {
                    
                    driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
                }, 200); // Ajusta este tiempo según sea necesario
            },
        }
      },
      
      {
        element: '#remesar-case-dialoggg',
        popover: {
          title: 'MODAL DE CONFIRMACION',
          description: 'Asegurate de dejar una observacion al confirmar el estatus de <strong>Remesar</strong> esto es importante para el seguimiento del caso.',
          onNextClick: () => {
                   console.log("Loading dynamic element5...");
                   funcionClick('cancel-remesar-buttongg');
                   setTimeout(() => {
                    
                    driverObj.moveNext(); // Continuar al siguiente paso después de que aparezca el modal
                }, 300); // Ajusta este tiempo según sea necesario
            },
        }
      },
      {
        element: '#remesar-case-dialoggg',
        popover: {
          title: 'COMPLETADO',
          description: "<img src='/celebration.jpg' style='height: 190px; width: 250px;' />¡Has completado el recorrido! Ahora sabes cómo gestionar los casos médicos en el sistema. Puedes explorar este recorrido en el modo demo",
          
        }
      },
    ]
  });

  driverObj.drive(); // ¡Importante! Inicia el tour aquí
};

// === Función para simular click real (compatible con frameworks) ===

function funcionClick(miBoton) {
  
    const boton = document.getElementById(miBoton);
    if (boton) {
      boton.click();
      console.log('Simulando click en el botón:', miBoton);
    }

    

}

function funcionClass(claseBoton) {
  const boton = document.querySelector('.' + claseBoton);
  if (boton) {
    boton.click();
    console.log('Simulando click en el botón con clase:', claseBoton);
  }
}

// Exportamos la instancia para poder detener el tour
export const stopTour = () => {
  if (driver.isActivated) {
    driver.reset(); // Detiene y limpia el tour
  }
};
